import { Stack } from 'expo-router';

import { primitive } from 'styles/constants';
import { isWeb } from 'utils/environment';

export default function DrawerLayout() {
  const transparentDrawerScreenOptions = {
    contentStyle: { backgroundColor: 'transparent' },
    animation: 'none' as const,
    ...(isWeb && {
      presentation: 'transparentModal' as const,
    }),
  };

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: primitive.$mayoEggWhite },
      }}
    >
      <Stack.Screen name="account/index" options={transparentDrawerScreenOptions} />
      <Stack.Screen name="notification-inbox" options={transparentDrawerScreenOptions} />
    </Stack>
  );
}
